module.exports = "./dist/assets/images/icons/6f18ad5389cd84d210e9250c0eb4aab7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/usersRights.png
// module id = ./assets/images/icons/usersRights.png
// module chunks = 0